import DOCUMENT_TYPE from '../enums/documents.enum';

export function returnSelectFilterOptions(clientId, selectFilterKey, features) {
  switch (selectFilterKey) {
    case 'document_types':
      return returnDocumentTypesOptions(clientId, features)?.filter(Boolean);

    default:
      return [];
  }
}

function returnOption(enumKey, key) {
  if (enumKey && enumKey?.[key] && enumKey?.properties?.[key]) {
    return {
      value: enumKey[key],
      name: enumKey.properties[key].display_name,
    };
  }
}

function returnDocumentTypesOptions(clientId, features) {
  const defaultOptions = [
    {
      value: '',
      name: 'Tous les types',
    },
    returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['DELIVERY-DETAIL-RESERVE-PHOTO']),
    returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['TOUR_RESERVE_PHOTO']),
  ];

  const featureBasedOptions = [
    features?.TOUR_START?.START_CHECKLIST?.enabled &&
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['COMMON-CHECKLIST']),
  ]?.filter(Boolean);

  if (clientId === 1) {
    return [
      ...defaultOptions,
      ...featureBasedOptions,
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE.PROOF_SIGN),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE.PROOF_PHOTO),
    ];
  } else if (clientId === 2 || clientId === 4) {
    return [
      ...defaultOptions,
      ...featureBasedOptions,
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE.PROOF_SIGN),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE.PROOF_PHOTO),
    ];
  } else if (clientId === 5) {
    return [
      ...defaultOptions,
      ...featureBasedOptions,
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['DELIVERY-DETAIL-DOCUMENT']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['DISINFECTION-DONE']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['COW-PURGE']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['DRIVER-LETTER']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['PREVIOUS-TOUR']),
    ];
  } else if (clientId === 6) {
    return [
      ...defaultOptions,
      ...featureBasedOptions,
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['DELIVERY-DETAIL-DOCUMENT']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['VEHICLE_PHOTO_FRONT']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['VEHICLE_PHOTO_BACK']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['CLIENT_PHOTOS']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['BEFORE_DELIVERY_PHOTO']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['AFTER_DELIVERY_PHOTO']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['ITEM-RESERVE-PHOTO']),
      returnOption(DOCUMENT_TYPE, DOCUMENT_TYPE['CLIENT_RESERVE_PHOTO']),
    ];
  }

  return [...defaultOptions, ...featureBasedOptions];
}
